<template>
  <div style="width: 100%">
    <div class="common-table">
      <div class="table-head">
        <span class="head-title margin-bottom-15">1.公对公转账信息</span>
        <span class="tips">请核对公对公转账信息后完成银行转账汇款。</span>
      </div>
      <div v-for="item in accountList" :key="item.key" class="table-row">
        <span>{{ item.name }}</span>
        <span
          >{{ getWLOptions ? getWLOptions[item.key] : "" }}
          <el-button
            v-if="item.key === 'receiveBankAccount'"
            class="copy-btn"
            @click="copyText(getWLOptions[item.key])"
            >复制</el-button
          ></span
        >
      </div>
    </div>
    <div class="common-table">
      <div class="table-head">
        <span class="tips1"
          >转账时用途备注“单位全称+联合采购专区会员服务费”。转账完成后，请您上传凭证提供银行盖章回执单，以便更快完成对公汇款确认。</span
        >
      </div>
    </div>
    <div class="common-table">
      <div class="table-head">
        <span class="head-title">2. 汇款信息</span>
      </div>
      <el-form
        ref="form"
        class="table-form"
        label-width="220px"
        :model="formData"
        :rules="rules"
      >
        <el-form-item label="汇款银行账户名称：" prop="bankAccountName">
          <el-input
            class="input-width"
            v-model="formData.bankAccountName"
            placeholder="请输入汇款银行账户名称："
          ></el-input>
        </el-form-item>
        <el-form-item label="汇款银行账户账号：" prop="bankAccount">
          <el-input
            class="input-width"
            v-model="formData.bankAccount"
            placeholder="请输入汇款银行账户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="汇款开户行全称：" prop="openBankFullName">
          <el-input
            class="input-width"
            v-model="formData.openBankFullName"
            placeholder="请输入汇款开户行全称"
          ></el-input>
        </el-form-item>
        <el-form-item label="转账附言/用途：" prop="transferRemark">
          <el-input
            class="input-width"
            v-model="formData.transferRemark"
            placeholder="请输入转账附言/用途"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付凭证附件：" prop="billPayFileReqBOS">
          <div class="bill-upload">
            <el-upload
              class="upload-demo"
              :action="uploadForm.action"
              :data="uploadData"
              :on-success="uploadSuccess"
              :show-file-list="false"
              :on-error="uploadError"
              :on-progress="onProgress"
              :headers="uploadForm.headers"
              multiple
            >
              <el-button size="small" type="primary">上传支付凭证</el-button>
            </el-upload>
            <div slot="tip" class="el-upload__tip">请上传银行盖章回执单</div>
          </div>
          <el-table
            :data="formData.billPayFileReqBOS"
            style="margin-top: 20px;"
            border
          >
            <el-table-column
              :show-overflow-tooltip="true"
              label="序号"
              type="index"
              width="50"
              height="36px"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              prop="fileName"
              label="文件名"
              width="200"
            >
              <template slot-scope="{ row }">
                <div class="file-download">
                  {{ row.fileName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="fileSize"
              label="文件大小"
              width="170"
            >
              <template slot-scope="{ row }">
                {{ row.fileSize ? row.fileSize + "kb" : "" }}
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              label="操作"
              align="left"
              appendixInfor.vue
            >
              <template slot-scope="{ $index, row }">
                <span
                  style="color: #FF142F;cursor: pointer"
                  @click="deleteRow($index, row)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group"></div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { addUrlPerFix } from "@/utils";
import { Loading } from "ccui";

const ACCOUNTS_MAP = [
  {
    name: "收款银行账户名称",
    key: "receiveBankName",
    info: "必填"
  },
  {
    name: "收款银行账户账号",
    key: "receiveBankAccount",
    info: "必填"
  },
  {
    name: "开户行",
    key: "openBankName",
    info: "必填"
  }
];
export default {
  name: "publicToPublic",
  data() {
    return {
      accountList: Object.freeze(ACCOUNTS_MAP),
      getWLOptions: {
        receiveBankName: "中交（厦门）电子商务有限公司",
        receiveBankAccount: "8110901013401328424",
        openBankName: "中信银行股份有限公司广州国际大厦支行"
      },
      formData: {
        bankAccountName: "",
        bankAccount: "",
        openBankFullName: "",
        transferRemark: "",
        billPayFileReqBOS: []
      },
      rules: {
        bankAccountName: [
          {
            required: true,
            message: "请输入汇款银行账户名称：",
            trigger: "blur"
          }
        ],
        bankAccount: [
          {
            required: true,
            message: "请输入汇款银行账户账号",
            trigger: "blur"
          },
          {
            pattern: /^\d{10,30}$/,
            message: "请输入正确的银行账号（10-30位数字）",
            trigger: "blur"
          }
        ],
        openBankFullName: [
          { required: true, message: "请输入汇款开户行全称", trigger: "blur" }
        ],
        transferRemark: [
          { required: true, message: "请输入转账附言/用途", trigger: "blur" }
        ],
        billPayFileReqBOS: [
          { required: true, message: "请上传文件", trigger: "change" },
          // 自定义校验（例如限制文件类型或大小）
          {
            validator: (rule, value, callback) => {
              if (this.formData.billPayFileReqBOS.length === 0) {
                callback(new Error("请上传文件"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      uploadForm: {
        action:
          addUrlPerFix(process.env.VUE_APP_BASE_URL) +
          "/apis/sra/reg/users/signup/uploadFileToOss", //上传图片
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      uploadData: {
        agentId: this.$router.history.current.query.a,
        openId: localStorage.getItem("supplierUserOpenId") || "",
        userName: localStorage.getItem("supplierUserName") || ""
      },
      uploadLoading: null
    };
  },
  mounted() {
    this.formData.transferRemark = " 联合采购专区会员服务费";
  },
  methods: {
    async uploadSuccess(res, file, fileList) {
      this.uploadLoading.close();
      this.$message.success("附件上传成功");
      console.log(res, "uploadSuccess");
      let fileData = res.data[0];
      this.formData.billPayFileReqBOS = [
        {
          fileUrl: fileData.downloadUrl,
          fileName: fileData.fileName,
          fileSize: fileData.fileSize,
          updateTime: fileData.updateTime,
          fileinfoType: fileData.fileType,
          uploadId: fileData.uploadId,
          credentialsUploadTime: fileData.updateTime
        }
      ];
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading.close();
    },
    onProgress(event, file, fileList) {
      this.uploadLoading = this.showLoading("上传中...");
    },
    deleteRow(index, row) {
      this.$confirm("确定删除？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      }).then(() => {
        this.formData.billPayFileReqBOS.splice(index, 1);
      });
    },
    // 表单校验
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve(this.formData);
          } else {
            resolve(false);
          }
        });
      });
    },
    copyText(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功！");
    },
    showLoading(text) {
      return Loading.service({
        lock: true,
        text: text,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.common-table {
  border: 1px solid #f1f1f1;
  margin: 20px;
  max-width: 100%;
  border-radius: 8px;
  overflow: hidden;
  .table-head {
    padding: 20px;
    background: #f9fafb;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    flex-direction: column;
  }
  .table-row {
    display: flex;
    justify-content: space-between;
    padding: 0 30% 0 20px;
    height: 49;
    line-height: 49px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #f1f1f1;
    span {
      flex: 1;
    }
  }
  .table-form {
    margin: 40px 10px;
  }
}

.margin-bottom-15 {
  margin-bottom: 15px;
}
.tips {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ff142f;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.tips1 {
  font-family: PingFangSC, PingFang SC;
  font-size: 13px;
  color: #4a4a4a;
}
.input-width {
  width: 500px;
}
.copy-btn {
  padding: 0 7px;
  height: 25px;
  border-color: red;
  color: red;
}
</style>
